import React, { useState, useEffect, useRef } from 'react';

// Sayfalar arası geçişte liste ve filtreler korunur; sayfaya dönünce önbellek anında gösterilir,
// arkada sessizce tazelenir.
const onbellek = {
    filtreler: { seciliAy: new Date().toISOString().slice(0, 7), seciliDurum: 'Takip Edilenler', aramaTerimi: '' },
    anahtar: null,
    siparisler: [],
    sayfa: 1,
    hasMore: true,
};

const SAYFA_BOYU = 30;

const filtreAnahtari =(ay, durum, arama) => `${ay}|${durum}|${arama.trim()}`;

function GonderiTakibi() {
    // --- STATE'LER ---
    const [seciliAy, setSeciliAy] = useState(onbellek.filtreler.seciliAy); // Bu ay default
    const [seciliDurum, setSeciliDurum] = useState(onbellek.filtreler.seciliDurum); // Varsayılan: Takip Edilenler
    const [aramaTerimi, setAramaTerimi] = useState(onbellek.filtreler.aramaTerimi);
    const ilkAnahtar = filtreAnahtari(seciliAy, seciliDurum, aramaTerimi);
    const onbellekVar = onbellek.anahtar === ilkAnahtar;
    const [siparisler, setSiparisler] = useState(onbellekVar ? onbellek.siparisler : []);
    const [loading, setLoading] = useState(!onbellekVar);

    // Infinite Scroll state'leri
    const [mevcut_sayfa, setMevcutSayfa] = useState(onbellekVar ? onbellek.sayfa : 1);
    const [hasMore, setHasMore] = useState(onbellekVar ? onbellek.hasMore : true);
    const [infiniteLoading, setInfiniteLoading] = useState(false);
    const [takipIslemde, setTakipIslemde] = useState(null); // takip durumu değiştirilen sipariş id'si
    const [sonOtomatikKontrol, setSonOtomatikKontrol] = useState(null);

    // Açılır bant state'leri
    const [acikSiparisId, setAcikSiparisId] = useState(null);
    const [detayData, setDetayData] = useState(null);
    const [kargoHareketleri, setKargoHareketleri] = useState([]);
    const [kargoSorguLoading, setKargoSorguLoading] = useState(false);

    // Yanıtlar sırasız gelebilir; yalnızca son isteğin sonucu ekrana yazılır
    const istekSayaciRef = useRef(0);

    // Liste değiştikçe önbelleği güncel tut
    useEffect(() => {
        onbellek.filtreler = { seciliAy, seciliDurum, aramaTerimi };
        onbellek.anahtar = filtreAnahtari(seciliAy, seciliDurum, aramaTerimi);
        onbellek.siparisler = siparisler;
        onbellek.sayfa = mevcut_sayfa;
        onbellek.hasMore = hasMore;
    }, [seciliAy, seciliDurum, aramaTerimi, siparisler, mevcut_sayfa, hasMore]);

    // --- FONKSİYONLAR ---

    // PTT durumlarını sadeleştiren fonksiyon (sadece gönderi takibi sayfası için)
    // backend/app.py içindeki ptt_durum_kategorisi ile aynı kurallar; sunucu filtreleri ona göre çalışır
    const normalizePttStatus = (barkodNo, sonIslem) => {
        if (!barkodNo || !sonIslem) {
            return "Barkodsuz";
        }

        // Teslim edilemedi: gönderi hâlâ PTT'de
        if (sonIslem.includes("Edilemedi") || sonIslem.includes("EDİLEMEDİ")) {
            return "Yolda";
        }

        // PTT'de aktif gönderi yok durumları
        if (sonIslem.includes("PTT'de Aktif Gönderi Yok") ||
            sonIslem.includes("bulunamadı") ||
            sonIslem.includes("bulunamadi") ||
            sonIslem.includes("İşleme Alınmadı") ||
            sonIslem.includes("Sorgulanamıyor") ||
            sonIslem.includes("sorgulanamıyor") ||
            sonIslem === "PTT Sorgusu Gerekiyor") {
            return "Kabul Yok";
        }

        // Teslim edildi durumları
        if (sonIslem.includes("Teslim") || sonIslem.includes("TESLİM")) {
            return "Teslim Edildi";
        }

        // Kargo oluşturulmadı
        if (sonIslem.includes("Kargo Oluşturulmadı") || sonIslem.includes("Oluşturulmadı")) {
            return "Barkodsuz";
        }

        // Geri kalan tüm hareketler yolda
        return "Yolda";
    };

    // Backend'den gönderi takibi verilerini çeken ana fonksiyon.
    // Sunucu PTT'yi canlı sorgulamaz (durumları saatlik otomatik görev günceller), yanıt hızlı döner.
    // sessiz: önbellekteki liste ekranda kalırken arkada tazeler (limit: yüklü satır sayısı kadar)
    const fetchGonderiTakibi = (sayfa = 1, append = false, sessiz = false) => {
        const token = localStorage.getItem('token');
        if (!token) {
            alert('Oturum süreniz dolmuş. Lütfen tekrar giriş yapın.');
            window.location.href = '/login';
            return;
        }

        if (append) {
            setInfiniteLoading(true);
        } else if (!sessiz) {
            setLoading(true);
        }
        const istekNo = ++istekSayaciRef.current;
        // Sessiz tazelemede yüklü sayfalar (30'un katı, en fazla 3 sayfa) tek istekte alınır
        const sessizSayfa = Math.min(3, Math.max(1, Math.ceil(siparisler.length / SAYFA_BOYU)));
        const limit = sessiz ? sessizSayfa * SAYFA_BOYU : SAYFA_BOYU;

        // URL parametrelerini oluştur
        const params = new URLSearchParams();
        if (seciliAy) params.append('ay', seciliAy);
        if (seciliDurum) params.append('gonderi_durumu', seciliDurum);
        if (aramaTerimi.trim()) params.append('arama', aramaTerimi.trim());
        params.append('sayfa', sayfa);
        params.append('limit', limit); // Infinite scroll için 30'ar yükle (sunucu en fazla 100 verir)

        fetch(`/api/siparisler/gonderi-takip?${params.toString()}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        })
        .then(res => {
            if (res.status === 401) {
                alert('Oturum süreniz dolmuş. Lütfen tekrar giriş yapın.');
                localStorage.removeItem('token');
                window.location.href = '/login';
                return;
            }
            return res.ok ? res.json() : Promise.reject('Veri çekilemedi');
        })
        .then(data => {
            if (istekNo !== istekSayaciRef.current || !data?.siparisler) return;
            // Siparişlerin PTT durumlarını normalize et
            const normalizedSiparisler = data.siparisler.map(siparis => ({
                ...siparis,
                son_islem_normalized: normalizePttStatus(siparis.barkod_no, siparis.son_islem),
                son_islem_original: siparis.son_islem // Orijinalini de sakla
            }));

            if (append) {
                // Infinite scroll - mevcut listeye ekle
                setSiparisler(prev => [...prev, ...normalizedSiparisler]);
                setMevcutSayfa(data.sayfalama.mevcut_sayfa);
            } else {
                // Yeni sorgu - listeyi değiştir
                setSiparisler(normalizedSiparisler);
                // Sessiz tazelemede birden çok sayfa tek seferde gelir; sonraki 30'luk sayfa buna göre devam eder
                setMevcutSayfa(sessiz ? sessizSayfa : data.sayfalama.mevcut_sayfa);
            }
            setHasMore(data.sayfalama.has_next);
        })
        .catch(error => {
            console.error('Hata:', error);
            if (!append && !sessiz && istekNo === istekSayaciRef.current) {
                setSiparisler([]);
            }
        })
        .finally(() => {
            if (istekNo === istekSayaciRef.current) setLoading(false);
            setInfiniteLoading(false);
        });
    };

    // Infinite Scroll fonksiyonu
    const loadMore = () => {
        if (hasMore && !infiniteLoading && !loading) {
            fetchGonderiTakibi(mevcut_sayfa + 1, true); // append=true
        }
    };

    // Tablo kutusu kendi içinde kaydırılıyor; sona yaklaşınca sonraki sayfayı yükle
    const handleTabloScroll = (e) => {
        const { scrollTop, clientHeight, scrollHeight } = e.currentTarget;
        if (scrollTop + clientHeight >= scrollHeight - 100) {
            loadMore();
        }
    };

    // Siparişi elle takibe al / takipten çıkar (10.000 TL ve üzeri siparişler otomatik takibe alınır)
    const handleTakipDegistir = async (siparis) => {
        const takipEt = !siparis.is_tracked;
        if (!takipEt && !window.confirm(`"${siparis.ad_soyad}" kişisine ait sipariş takipten çıkarılacak. Emin misiniz?`)) return;
        setTakipIslemde(siparis.id);
        try {
            const res = await fetch(`/api/siparisler/${siparis.id}/durum-guncelle`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('token')}` },
                body: JSON.stringify({ is_tracked: takipEt })
            });
            if (!res.ok) {
                const data = await res.json().catch(() => ({}));
                throw new Error(data.hata || 'Sunucu hatası.');
            }
            setSiparisler(prev => (!takipEt && seciliDurum === 'Takip Edilenler')
                ? prev.filter(s => s.id !== siparis.id)
                : prev.map(s => (s.id === siparis.id ? { ...s, is_tracked: takipEt } : s)));
        } catch (err) {
            alert(`Takip durumu değiştirilemedi: ${err.message}`);
        } finally {
            setTakipIslemde(null);
        }
    };

    // Sayfa yüklendiğinde ve filtreler değiştiğinde verileri çek
    const ilkYuklemeRef = useRef(true);
    useEffect(() => {
        if (ilkYuklemeRef.current) {
            ilkYuklemeRef.current = false;
            // Önbellekte bu filtrenin listesi varsa ekranda kalır, arkada tazelenir
            fetchGonderiTakibi(1, false, onbellekVar);
            return;
        }
        setMevcutSayfa(1); // Filtre değiştiğinde ilk sayfaya dön
        setHasMore(true);  // Infinite scroll'u resetle
        fetchGonderiTakibi(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [seciliAy, seciliDurum]);

    // Arama otomatik olsun (typing sırasında)
    const ilkAramaRef = useRef(true);
    useEffect(() => {
        // İlk açılışta yukarıdaki efekt zaten yüklüyor; aynı isteği ikinci kez atma
        if (ilkAramaRef.current) {
            ilkAramaRef.current = false;
            return;
        }
        const delayedSearch = setTimeout(() => {
            setMevcutSayfa(1);
            setHasMore(true);
            fetchGonderiTakibi(1);
        }, 500); // 500ms delay ile arama yap

        return () => clearTimeout(delayedSearch);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [aramaTerimi]); // aramaTerimi değiştiğinde çalışsın

    // Durumlar saatlik otomatik PTT kontrolüyle güncellenir; son çalışma zamanı gösterilir
    useEffect(() => {
        fetch('/api/bekleyen-kargolar/otomatik-kontrol-durumu', {
            headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
        })
            .then(res => (res.ok ? res.json() : null))
            .then(data => setSonOtomatikKontrol(data?.son_calisma?.bitis || null))
            .catch(() => {});
    }, []);

    // Ödeme yöntemleri için renkler ve tam isimler
    const odemeRenkleri = { E: '#6761a8', D: '#bb999c', K: '#17bebb', O: '#2c6184', B: '#a32e68' };
    const odemeYontemleri = { E: 'EFT/Havale', D: 'Kurum Ödemesi', K: 'Kapıda Ödeme', O: 'Online Ödeme', B: 'Ücretsiz Gönderi' };

    // Satır tıklama ve detay açma fonksiyonu
    const handleRowClick = async (siparisId) => {
        if (acikSiparisId === siparisId) {
            // Zaten açık olan satırı kapat
            setAcikSiparisId(null);
            setDetayData(null);
            setKargoHareketleri([]);
        } else {
            // Yeni satırı aç
            setAcikSiparisId(siparisId);
            setDetayData(null);
            setKargoHareketleri([]);

            try {
                const token = localStorage.getItem('token');
                const response = await fetch(`/api/siparisler/${siparisId}`, {
                    headers: { 'Authorization': `Bearer ${token}` }
                });

                if (response.ok) {
                    const data = await response.json();
                    setDetayData(data);

                    // Eğer barkod varsa kargo hareketlerini de getir
                    if (data.kargo_takip_no) {
                        await fetchKargoHareketleri(data.kargo_takip_no);
                    }
                }
            } catch (error) {
                console.error('Sipariş detayı getirilemedi:', error);
            }
        }
    };

    // Kargo hareketlerini getir - SiparisListesi ile aynı endpoint, tüm hareketler
    const fetchKargoHareketleri = async (barkodNo) => {
        setKargoSorguLoading(true);
        try {
            const token = localStorage.getItem('token');
            const response = await fetch(`/api/kargo-takip/${barkodNo}?limit=0`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });

            if (response.ok) {
                const data = await response.json();
                setKargoHareketleri(data || []);
            } else {
                console.error('Kargo takip API hatası:', response.status);
                setKargoHareketleri([]);
            }
        } catch (error) {
            console.error('Kargo hareketleri getirilemedi:', error);
            setKargoHareketleri([]);
        } finally {
            setKargoSorguLoading(false);
        }
    };

    // Gönderi durumu için stil döndüren fonksiyon - Sadeleştirilmiş kategoriler
    const getGonderiDurumStyle = (normalizedStatus) => {
        switch(normalizedStatus) {
            case 'Barkodsuz':
                return { background: '#f8d7da', color: '#721c24', border: '1px solid #f5c6cb' }; // Kırmızı

            case 'Kabul Yok':
                return { background: '#e2e3e5', color: '#383d41', border: '1px solid #d6d8db' }; // Gri

            case 'Teslim Edildi':
                return { background: '#d4edda', color: '#155724', border: '1px solid #c3e6cb' }; // Yeşil

            case 'Yolda':
                return { background: '#fff3cd', color: '#856404', border: '1px solid #ffeeba' }; // Sarı

            default:
                return { background: '#e2e3e5', color: '#383d41', border: '1px solid #d6d8db' }; // Varsayılan - Gri
        }
    };

    return (
        <div style={{ background: '#F8F8F8', padding: '20px', borderRadius: '8px', height: 'calc(100vh - 110px)', display: 'flex', flexDirection: 'column', overflow: 'hidden', boxSizing: 'border-box' }}>
            <style>{`
                .siparis-satiri {
                    transition: all 0.2s ease-in-out;
                }
                .siparis-satiri:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.1);
                    z-index: 10;
                    position: relative;
                }

                @keyframes spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                }
            `}</style>

            <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '25px',
                marginBottom: '20px',
                padding: '15px',
                background: '#F8F8F8',
                borderRadius: '8px',
                fontFamily: 'Poppins, sans-serif'
            }}>

                {/* Ay Filtresi */}
                <div>
                    <label style={{ fontWeight: '500', marginRight: '10px' }}>Ay Seçiniz:</label>
                    <input
                        type="month"
                        value={seciliAy}
                        onChange={(e) => setSeciliAy(e.target.value)}
                        style={{
                            padding: '6px',
                            border: '1px solid #ccc',
                            borderRadius: '4px',
                            fontFamily: 'Poppins, sans-serif'
                        }}
                    />
                </div>

                {/* Gönderi Durumu Filtresi */}
                <div>
                    <label style={{ fontWeight: '500', marginRight: '10px' }}>Gönderi Durumu:</label>
                    <select
                        value={seciliDurum}
                        onChange={(e) => setSeciliDurum(e.target.value)}
                        style={{
                            padding: '6px',
                            border: '1px solid #ccc',
                            borderRadius: '4px',
                            minWidth: '180px',
                            fontFamily: 'Poppins, sans-serif'
                        }}
                    >
                        <option value="Takip Edilenler">Takip Edilenler</option>
                        <option value="">Tümü</option>
                        <option value="Barkodsuz">Barkodsuz</option>
                        <option value="Kabul Yok">Kabul Yok</option>
                        <option value="Yolda">Yolda</option>
                        <option value="Teslim Edildi">Teslim Edildi</option>
                    </select>
                </div>

                {/* Arama Kutusu */}
                <div>
                    <input
                        type="text"
                        placeholder="Müşteri, Tel, Sipariş No, Barkod Ara..."
                        value={aramaTerimi}
                        onChange={(e) => setAramaTerimi(e.target.value)}
                        style={{
                            padding: '6.5px',
                            border: '1px solid #ccc',
                            borderRadius: '4px',
                            width: '300px',
                            fontFamily: 'Poppins, sans-serif'
                        }}
                    />
                </div>

                {sonOtomatikKontrol && (
                    <div style={{ marginLeft: 'auto', fontSize: '12px', color: '#777' }}
                        title="PTT durumları 07:00-22:00 arası saatte bir otomatik güncellenir">
                        Son PTT güncellemesi: {new Date(sonOtomatikKontrol).toLocaleString('tr-TR', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' })}
                    </div>
                )}
            </div>

            {loading ? (
                <div style={{ textAlign: 'center', padding: '50px', fontFamily: 'Poppins, sans-serif' }}>
                    Yükleniyor...
                </div>
            ) : (
                <div onScroll={handleTabloScroll} style={{ flex: 1, overflowY: 'auto', borderRadius: '8px', border: '1px solid #eee', background: 'white' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px', fontFamily: 'Poppins, sans-serif' }}>
                    <thead style={{ position: 'sticky', top: 0, zIndex: 20 }}>
                        <tr style={{ background: '#E5E5E5', height: '40px' }}>
                            <th style={{ position: 'sticky', top: 0, background: '#E5E5E5', zIndex: 20, padding: '12px', textAlign: 'left', fontWeight: '500' }}>Sipariş Tarihi</th>
                            <th style={{ position: 'sticky', top: 0, background: '#E5E5E5', zIndex: 20, padding: '12px', textAlign: 'left', fontWeight: '500' }}>Telefon</th>
                            <th style={{ position: 'sticky', top: 0, background: '#E5E5E5', zIndex: 20, padding: '12px', textAlign: 'left', fontWeight: '500' }}>Ad Soyad</th>
                            <th style={{ position: 'sticky', top: 0, background: '#E5E5E5', zIndex: 20, padding: '12px', textAlign: 'left', fontWeight: '500' }}>İl/İlçe</th>
                            <th style={{ position: 'sticky', top: 0, background: '#E5E5E5', zIndex: 20, padding: '12px', textAlign: 'center', fontWeight: '500', width: '120px' }}>Toplam Bedel</th>
                            <th style={{ position: 'sticky', top: 0, background: '#E5E5E5', zIndex: 20, padding: '12px', textAlign: 'center', fontWeight: '500', width: '120px' }}>Ödeme Yöntemi</th>
                            <th style={{ position: 'sticky', top: 0, background: '#E5E5E5', zIndex: 20, padding: '12px', textAlign: 'center', fontWeight: '500', width: '140px' }}>Barkod No</th>
                            <th style={{ position: 'sticky', top: 0, background: '#E5E5E5', zIndex: 20, padding: '12px', textAlign: 'center', fontWeight: '500', width: '120px' }}>Son İşlem</th>
                            <th style={{ position: 'sticky', top: 0, background: '#E5E5E5', zIndex: 20, padding: '12px', textAlign: 'center', fontWeight: '500', width: '120px' }}>Takip</th>
                        </tr>
                    </thead>
                    <tbody>
                        {siparisler.length > 0 ? (
                            siparisler.map((siparis) => (
                                <React.Fragment key={siparis.id}>
                                    <tr className="siparis-satiri"
                                        style={{
                                            background: siparis.kargo_durumu === 'Beklemede' ? '#fff4ccff' :
                                                       siparis.kargo_durumu === 'Acil' ? '#ffeeee' :
                                                       '#ffffff',
                                            height: '24px',
                                            borderBottom: '1px solid #eee',
                                            borderLeft: siparis.kargo_durumu === 'Beklemede' ? '4px solid #ffc107' :
                                                       siparis.kargo_durumu === 'Acil' ? '4px solid #dc3545' :
                                                       'none',
                                            cursor: 'pointer'
                                        }}
                                        onClick={() => handleRowClick(siparis.id)}
                                    >
                                    <td style={{ padding: '12px' }}>{siparis.siparis_tarihi}</td>
                                    <td style={{ padding: '12px' }}>{siparis.telefon}</td>
                                    <td style={{ padding: '12px' }}>{siparis.ad_soyad}</td>
                                    <td style={{ padding: '12px' }}>{siparis.il_ilce}</td>
                                    <td style={{ padding: '12px', textAlign: 'center' }}>
                                        {(siparis.toplam_bedel || 0).toFixed(2)} ₺
                                    </td>
                                    <td style={{ padding: '12px', textAlign: 'center' }}>
                                        <div style={{
                                            background: odemeRenkleri[siparis.odeme_yontemi] || '#6c757d',
                                            color: 'white',
                                            padding: '3px 8px',
                                            borderRadius: '4px',
                                            display: 'inline-block',
                                            fontSize: '12px',
                                            fontWeight: 'regular',
                                            textAlign: 'center',
                                            minWidth: '100px'
                                        }}>
                                            {odemeYontemleri[siparis.odeme_yontemi] || siparis.odeme_yontemi}
                                        </div>
                                    </td>
                                    <td style={{ padding: '12px', textAlign: 'center', fontSize: '11px' }}>
                                        {siparis.barkod_no || '-'}
                                    </td>
                                    <td style={{ padding: '12px', textAlign: 'center', fontSize: '12px' }}>
                                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                                            <span
                                                style={{
                                                    padding: '3px 8px',
                                                    borderRadius: '4px',
                                                    ...getGonderiDurumStyle(siparis.son_islem_normalized)
                                                }}
                                                title={`Detay: ${siparis.son_islem_original || siparis.son_islem}${siparis.ptt_son_sorgu ? `\nSorgu: ${siparis.ptt_son_sorgu}` : ''}`} // Tooltip ile orijinal durumu göster
                                            >
                                                {siparis.son_islem_normalized}
                                            </span>
                                        </div>
                                    </td>
                                    <td style={{ padding: '12px', textAlign: 'center' }} onClick={(e) => e.stopPropagation()}>
                                        <button
                                            type="button"
                                            disabled={takipIslemde === siparis.id}
                                            onClick={() => handleTakipDegistir(siparis)}
                                            title={siparis.is_tracked ? 'Takipten çıkar' : 'Siparişi takip listesine al'}
                                            style={{
                                                padding: '4px 10px',
                                                fontSize: '12px',
                                                borderRadius: '4px',
                                                cursor: takipIslemde === siparis.id ? 'not-allowed' : 'pointer',
                                                fontFamily: 'Poppins, sans-serif',
                                                whiteSpace: 'nowrap',
                                                ...(siparis.is_tracked
                                                    ? { background: '#fff', border: '1px solid #dc3545', color: '#dc3545' }
                                                    : { background: '#fff', border: '1px solid #6f42c1', color: '#6f42c1' })
                                            }}
                                        >
                                            {siparis.is_tracked ? 'Takipten Çıkar' : 'Takip Et'}
                                        </button>
                                    </td>
                                </tr>

                                {/* Açılır Detay Bantı */}
                                {acikSiparisId === siparis.id && (
                                    <tr className="detay-bandi">
                                        <td colSpan="9" style={{ padding: '15px', background: '#f8f9fa', borderTop: '1px solid #dee2e6' }}>
                                            {!detayData ? (
                                                <div style={{ textAlign: 'center', padding: '20px', fontFamily: 'Poppins, sans-serif' }}>
                                                    Detaylar yükleniyor...
                                                </div>
                                            ) : (
                                                <div style={{ fontFamily: 'Poppins, sans-serif' }}>
                                                    {detayData.kargo_takip_no ? (
                                                        <div>
                                                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', marginBottom: '15px' }}>
                                                                <p style={{ fontSize: '14px', marginBottom: '0', fontWeight: 'bold' }}>
                                                                    Gönderi Takip No:
                                                                    <span style={{
                                                                        marginLeft: '8px',
                                                                        padding: '4px 10px',
                                                                        background: '#e9ecef',
                                                                        borderRadius: '4px',
                                                                        fontFamily: 'monospace',
                                                                        fontSize: '13px'
                                                                    }}>
                                                                        {detayData.kargo_takip_no}
                                                                    </span>
                                                                </p>
                                                            </div>
                                                            <div style={{
                                                                maxHeight: '200px',
                                                                overflowY: 'auto',
                                                                border: '1px solid #dee2e6',
                                                                borderRadius: '4px',
                                                                background: 'white'
                                                            }}>
                                                                {kargoHareketleri.length > 0 ? (
                                                                    kargoHareketleri.map((hareket, index) => (
                                                                        <div key={index} style={{
                                                                            padding: '8px 12px',
                                                                            borderBottom: index < kargoHareketleri.length - 1 ? '1px solid #f1f3f4' : 'none',
                                                                            fontSize: '12px'
                                                                        }}>
                                                                            <div style={{ fontWeight: 'bold', color: '#495057', marginBottom: '2px' }}>
                                                                                {hareket.durum}
                                                                            </div>
                                                                            <div style={{ color: '#6c757d' }}>
                                                                                📍 {hareket.yer}
                                                                            </div>
                                                                            <div style={{ color: '#6c757d', fontSize: '11px' }}>
                                                                                🕐 {hareket.tarih} {hareket.saat}
                                                                            </div>
                                                                        </div>
                                                                    ))
                                                                ) : (
                                                                    <div style={{ padding: '15px', textAlign: 'center', color: '#6c757d', fontSize: '12px' }}>
                                                                        {kargoSorguLoading ? 'Hareketler sorgulanıyor...' : 'Henüz hareket bulunamadı veya sorgu yapılmadı.'}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <div style={{ textAlign: 'center', padding: '20px', color: '#6c757d', fontSize: '13px' }}>
                                                            Henüz kargo takip numarası oluşturulmamış.
                                                        </div>
                                                    )}
                                                </div>
                                            )}
                                        </td>
                                    </tr>
                                )}
                            </React.Fragment>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="9" style={{ padding: '20px', textAlign: 'center', fontStyle: 'italic' }}>
                                    {seciliDurum === 'Takip Edilenler'
                                        ? 'Bu ay takip edilen sipariş yok. 10.000 TL ve üzeri siparişler otomatik takibe alınır; diğerlerini "Tümü" seçip "Takip Et" ile ekleyebilirsiniz.'
                                        : 'Veri bulunamadı.'}
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
                </div>
            )}

            {/* Infinite Scroll Loading Indicator */}
            {infiniteLoading && (
                <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    padding: '20px',
                    fontFamily: 'Poppins, sans-serif',
                    color: '#000000'
                }}>
                    <div style={{
                        width: '20px',
                        height: '20px',
                        border: '2px solid #000000',
                        borderTop: '2px solid transparent',
                        borderRadius: '50%',
                        animation: 'spin 1s linear infinite',
                        marginRight: '10px'
                    }}></div>
                    Daha fazla sipariş yükleniyor...
                </div>
            )}

            {/* Scroll'un sonuna gelindiğinde göster */}
            {!hasMore && !loading && siparisler.length > 0 && (
                <div style={{
                    textAlign: 'center',
                    padding: '20px',
                    fontFamily: 'Poppins, sans-serif',
                    color: '#6c757d',
                    borderTop: '1px solid #eee',
                    marginTop: '20px'
                }}>
                    <span style={{ fontSize: '18px' }}>🎉</span> Tüm siparişler yüklendi!
                </div>
            )}
        </div>
    );
}

export default GonderiTakibi;
